import React from 'react'
import { Jumbotron, Container } from 'react-bootstrap'

export default function Footer() {

  return (
    <Jumbotron fluid className="footer">
      <Container>
        <h6>SUSHI-APP</h6>
      </Container>
    </Jumbotron>
  )

}
